import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import { getComponentsSideData } from "assets/data/sideTabData";
import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import PreviewToasterComponent from "components/DesignSystemPage/ToasterComponent/PreviewToasterComponent";
import UsageToasterComponent from "components/DesignSystemPage/ToasterComponent/UsageToasterComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";
import { toasterTokenTabData } from "assets/data/tokenTabData";

import "assets/scss/pages/_DesignSystemComponents.scss";

const Toaster = () => {
  const { id } = useParams();
  const { designSystemMeta, designSystem } = useGlobalContext();

  const componentName = "toaster";
  const componentKey = `Component/${componentName}`;
  const componentData = designSystem[componentKey];
  const tokenTableData = toasterTokenTabData(componentData, componentName);

  const tabData = ["Default"];
  const tabs = ["Preview", "Usage", "Tokens"];

  

  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const bannerData = {
    heading: "Toaster",
    description:
      "Add, replace, generate colors which makes your design looks awesome!",
    bannerImage: designSystemMeta.banner_url,
  };

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <PreviewToasterComponent
            tabData={tabData}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            setSelectedTab={setSelectedTab}
          />
        );
      case 1:
        return <UsageToasterComponent />;
      case 2:
        return (
          // <TokenTableComponent
          //   tabData={toasterTabData}
          //   tokenTableData={tokenTableData}
          // />
           <TokenTableComponent tokenTableData={tokenTableData} />
        );
      default:
        return null;
    }
  };
  return (
    <DesignSystemLayout
      bannerData={bannerData}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabs={tabs}
      sideTabs={getComponentsSideData(id)}
      title='Components'
    >
      {renderContent()}
    </DesignSystemLayout>
  );
};

export default Toaster;
